import styled from 'styled-components';

export const WidgetWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 3%;
  gap: 2%;
`;

export const TransitWrapper = styled.div`
  display: flex;
  overflow-x: hidden;
  height: 100%;
`;

export const SpinnerContainer = styled.div`
  height: 100%;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`;

export const NoStationsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const StationsWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  gap: 2%;
  display: flex;
  flex-direction: column;
`;
